import React, { FC, useCallback } from "react";
import WeChatQRCode from "./WeChatQRCode";

const QRCodeLogin: FC = () => {
  const handlerToBindPhone = useCallback(() => {
    // 外部接收验证成功，以备以后有其他的二维码登录方式
    //dispatch(loginSlice.actions.openBindPhoneDialog());
  }, []);

  return <WeChatQRCode onSuccess={handlerToBindPhone} />;
};

export default QRCodeLogin;
